import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminGuard} from "./admin/admin.guard";
import {AboutComponent} from "./about/component/about.component";

const routes: Routes = [
    {path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule)},
    {path: 'about',component: AboutComponent},
    {path: 'shop',loadChildren: () =>import('./shop/shop.module').then(m => m.ShopModule)},
    {path: 'shop/:id',loadChildren: () =>import('./shop/shop.module').then(m => m.ShopModule)},
    {path: 'contact',loadChildren: () =>import('./contact/contact.module').then(m => m.ContactModule)},
    {path: 'cart',loadChildren: () =>import('./cart/cart.module').then(m => m.CartModule)},
    {path: 'wishlist',loadChildren: () =>import('./wishlist/wishlist.module').then(m => m.WishlistModule)},
    {path: 'testimonial',loadChildren: () =>import('./testimonial/testimonial.module').then(m => m.TestimonialModule)},
    {path: 'account',loadChildren: () =>import('./account/account.module').then(m => m.AccountModule)},
    {path: 'policy',loadChildren: () =>import('./policy/policy.module').then(m => m.PolicyModule)},
    {path: 'checkout',loadChildren: () =>import('./checkout/checkout.module').then(m => m.CheckoutModule)},
    {path: 'admin',loadChildren: () =>import('./admin-panel/admin-panel.module').then(m => m.AdminPanelModule), canActivate:[AdminGuard]},
    {path: '', redirectTo: '/home', pathMatch: 'full'},
    {path: '**', redirectTo: ''}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top'
        })
    ],
    exports: [RouterModule]
})

export class AppRoutingModule {
}